module.exports = __webpack_public_path__ + "static/media/icon-totalSpace.3fb9db45.svg";